import React from 'react';
import './work.css';

function OAG () {
  return (
    <div className='section body-section-below-title'>
      <div className='experience-logos'>
        <a
          href='https://www.oag-bvg.gc.ca/internet/English/admin_e_41.html'
          style={{ cursor: 'pointer' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            className='experience-company-logo'
            alt='OAG-BVG Logo'
            src='/assets/OAG-BVG.png'
          />
        </a>

        <div className='techs-logos'>
          <img
            className='tech-logo'
            src='/assets/angular.png'
            alt='Angular Logo'
          />
          <img
            className='tech-logo'
            src='/assets/netcore.png'
            alt='.NET core Logo'
          />
          <img
            className='tech-logo'
            src='/assets/drupal.png'
            alt='Drupal Logo'
          />
        </div>
      </div>
      <div className='experience-text'>
        <div className='experience-title'>
          <div style={{ flexDirection: 'column' }}>
            <span style={{ fontSize: '22px', fontWeight: 'lighter' }}>
              Senior Web Developer
            </span>
            <br />
            <span style={{ fontSize: '14px', fontWeight: 'lighter' }}>
              Office of the Auditor General of Canada, Ottawa, Canada
            </span>
          </div>
          <span style={{ fontWeight: 'lighter' }}>01/2017 - 04/2018</span>
        </div>

        <div className='experience-body'>
          <ul>
            <li>
              Pioneered the use of Angular, enabling the creation of a human
              resources system on top of legacy software
            </li>
            <li>
              Maintained Drupal 7 website, enabling 500 auditors to develop new
              auditing methodology
            </li>
            <li>
              Created an email notification system using Angular and .NET Core
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default OAG;
